import { useEffect, useState } from "react";
import css from "../main/main.module.css";
import PopularVideo from "../catalog/popularVideo";
import Loader from "../standartComponents/loader";

const levelNumberMap = {
  A1: 1,
  A2: 2,
  B1: 3,
  B2: 4,
  C1: 5,
  C2: 6,
};

const AllVideosView = ({ 
  authUser,
  categories = [],
  selectedCategories = [],
  selectedLevel,
  lessonsByCategory = {},
  allLevels = [],
  searchQuery = "",
}) => {
  const [isLoading, setIsLoading] = useState(true);
  
  console.log('AllVideosView render:', {
    categories: categories.length,
    selectedCategories,
    selectedLevel,
    lessonsByCategoryCount: Object.keys(lessonsByCategory).length,
    allLevels: allLevels?.length
  });

  const getAllChildCategories = (parentId, allCats) => {
    const children = allCats.filter((cat) => cat.parent === parentId);
    let allIds = children.map((cat) => cat.id);
    children.forEach((child) => {
      allIds = [...allIds, ...getAllChildCategories(child.id, allCats)];
    });
    return allIds;
  };

  const getLevelName = (levelId) => {
    const level = allLevels?.find(l => l.id === Number(levelId));
    return level?.name || 'A2';
  };

  useEffect(() => {
    setIsLoading(false);
  }, []);



  if (isLoading) {
    return (
      <div className={css.centrSpiner}>
        <Loader />
      </div>
    );
  }

  return (
    <div className={css.allMainWrap}>
      {/* Video grid/sections below filters (filters now in NavigationTabs) */}
      {categories.map((category) => {
        const childCategoryIds = getAllChildCategories(category.id, categories);
        const allLessons = lessonsByCategory[category.id] || [];
        
        console.log(`Processing category ${category.name}:`, { 
          lessonsCount: allLessons.length,
          selectedLevel,
          isSelected: selectedCategories.length === 0 || selectedCategories.includes(category.id)
        });

        const isSelected =
          selectedCategories.length === 0 ||
          selectedCategories.some((id) =>
            [category.id, ...childCategoryIds].includes(id)
          );

        let filteredLessons = allLessons;
        
        if (selectedLevel) {
          // Map level groups to their corresponding level numbers
          const levelGroups = {
            beginner: [1, 2], // A1, A2
            intermediate: [3, 4], // B1, B2
            advanced: [5, 6], // C1, C2
          };

          // If it's a group, filter by all levels in that group
          if (levelGroups[selectedLevel]) {
            filteredLessons = filteredLessons.filter(
              (lesson) => levelGroups[selectedLevel].includes(Number(lesson.video.languageLevel))
            );
          } else {
            // If it's a specific level (like A1, B2, etc), filter by that level's number
            const levelNumber = levelNumberMap[selectedLevel];
            if (levelNumber) {
              filteredLessons = filteredLessons.filter(
                (lesson) => Number(lesson.video.languageLevel) === levelNumber
              );
            }
          }
        }

        if (searchQuery) {
          filteredLessons = filteredLessons.filter((lesson) =>
            lesson.video.name.toLowerCase().includes(searchQuery.toLowerCase())
          );
        }

        if (isSelected && filteredLessons.length > 0) {
          return (
            <PopularVideo
              allLevels={allLevels}
              key={category.id}
              category={category}
              lessons={filteredLessons}
            />
          );
        }
        return null;
      })}
      {!categories.some(cat => lessonsByCategory[cat.id]?.length > 0) && (
        <div className={css.centrSpiner}>
          <p>No videos match the selected filters</p>
        </div>
      )}
      <div className={css.buffer}></div>
    </div>
  );
};

export default AllVideosView;